import React from 'react';
import { PropInfo, CodeExample, ProgressBarProps } from '@cimpress/react-components';

import ProgressBarCode from '!raw-loader!./progressbar.jsx';
import ProgressBarDemo from './progressbar.jsx';
import ComponentDoc from '../../shared/TabbedComponentDoc';

const ProgressBarDocs = () => {
  const propInfos: PropInfo<ProgressBarProps>[] = [
    {
      name: 'size',
      type: 'string',
      description: (
        <div>
          The height of the progress bar. One of the following:
          <ul>
            <li>s</li>
            <li>m</li>
            <li>l</li>
            <li>xl</li>
          </ul>
        </div>
      ),
      default: 's',
    },
    {
      name: 'status',
      type: 'string',
      description: (
        <div>
          The status determining the status color to apply to the progress bar. One of the following:
          <ul>
            <li>success</li>
            <li>warning</li>
            <li>danger</li>
            <li>info</li>
          </ul>
        </div>
      ),
      default: '',
    },
    {
      name: 'color',
      type: 'string',
      description: (
        <div>
          The color of the progress bar. If <code>type</code> is provided, then <code>color</code> will be ignored.
        </div>
      ),
      default: '',
    },
    {
      name: 'value',
      type: 'number (required)',
      description: 'The current value of the progress bar. Must be a number from 0 to 100.',
      default: '',
    },
    {
      name: 'className',
      type: 'string',
      description: 'Additional class names to add to the progress bar.',
      default: '',
    },
  ];
  return (
    <ComponentDoc name="Progress Bar" propInfos={propInfos}>
      <ProgressBarDemo />
      <CodeExample code={ProgressBarCode} />
    </ComponentDoc>
  );
};

export default ProgressBarDocs;
